<template>
  <div>
    <home-nav-bar title="编辑溯源">
      <template #left>
        <router-link :to="{name: 'TracePacking',query:{traceCode}}">
          <van-icon name="arrow-left" />
        </router-link>
        <!-- <div /> -->
      </template>
    </home-nav-bar>
    <div class="main">
      <div class="packing-info list">
        <van-cell :value="productState|perfect" :value-class="{improved:true}" is-link @click.native="packingEdit">
          <template #title>
            <svg-icon class="icon" icon-class="crop" />
            产品信息
          </template>
        </van-cell>
      </div>
      <!-- 证书 -->
      <div class="report-info list">
        <van-cell>
          <template #title>
            <div>
              <svg-icon class="icon" icon-class="microscope" />
              权威检测（至少添加一项）
            </div>
          </template>
          <template #default>
            <van-switch v-model="reportList" size="20px" />
          </template>
        </van-cell>
        <div v-if="reportList">
          <van-cell
            v-for="(item,key) in form.reportInfo"
            :key="item.id"
            :title="item.testProject"
            is-link
            @click="editReport(item,key)"
          />
          <van-cell is-link title="添加自定义证书" @click="createReport" />
        </div>
      </div>
      <!-- 产地 -->
      <div class="origin-info list">
        <van-cell>
          <template #title>
            <!-- <svg-icon icon-class="safe" class="icon" /> -->
            <van-icon class="icon" name="location-o" size="20" />
            产地信息
          </template>
        </van-cell>
        <van-cell
          :value="cameraState|perfect"
          :value-class="{improved:cameraState}"
          is-link
          title="摄像头"
          @click="showNoBinding(cameraState)"
        />
        <van-cell
          :value="deviceState|perfect"
          :value-class="{improved:deviceState}"
          is-link
          title="传感器"
          @click="showNoBinding(deviceState)"
        />
      </div>
      <!-- 加工 -->
      <div class="process-info list">
        <van-cell :value="processState|perfect" is-link @click="processEdit">
          <template #title>
            <svg-icon class="icon" icon-class="process" />
            加工环节
          </template>
        </van-cell>
      </div>
      <div class="submit-box">
        <van-button class="submit" round type="info" @click="submit">
          更新并查看溯源
        </van-button>
      </div>
    </div>
    <trace-product-popup
      :init-form-data="popup.product.initFormData"
      :visible.sync="popup.product.visible"
      @confirm="confirmProductFn"
    />
    <trace-raw-popup
      :init-form-data="popup.raw.initFormData"
      :visible.sync="popup.raw.visible"
      @confirm="confirmRawFn"
    />
    <trace-process-popup
      :init-form-data="popup.process.initFormData"
      :visible.sync="popup.process.visible"
      @confirm="confirmProcessFn"
    />
    <trace-report-popup
      :form-type="popup.report.formType"
      :init-form-data="popup.report.initFormData"
      :visible.sync="popup.report.visible"
      @confirm="confirmReportFn"
      @delfirm="delfirmFn"
    />
    <trace-device-status
      :device-length.sync="popup.iot.deviceLength"
      :visible.sync="popup.iot.show"
      type="iot"
    />
  </div>
</template>

<script>
import api from '@/api'
import { deepClone, img2String } from '@/utils/tool'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import TraceProductPopup from '@/views/packing/components/TraceInfo/TraceProductPopup'
import TraceRawPopup from '@/views/packing/components/TraceInfo/TraceRawPopup'
import TraceProcessPopup from '@/views/packing/components/TraceInfo/TraceProcessPopup'
import TraceReportPopup from '@/views/packing/components/TraceInfo/TraceReportPopup'
import TraceDeviceStatus from '@/views/productManage/TraceSource/components/TraceDeviceStatus'

export default {
  name: 'TraceSourceEditor',
  components: { HomeNavBar, TraceProductPopup, TraceRawPopup, TraceProcessPopup, TraceReportPopup, TraceDeviceStatus },
  filters: {
    perfect: (val) => {
      return val ? '已完善' : '待完善'
    }
  },
  props: {
    // 通过绑定 route.query 传递
    traceCode: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      reportList: false,
      popup: {
        product: {
          visible: false,
          initFormData: {}
        },
        raw: {
          visible: false,
          initFormData: {}
        },
        process: {
          visible: false,
          initFormData: {}
        },
        report: {
          visible: false,
          formType: 'create',
          initFormData: {}
        },
        iot: {
          show: false
        }
      },
      form: {},
      cameraState: false,
      deviceState: false
    }
  },
  computed: {
    productState() {
      return !!((this.form.productName || this.form.productPhoto || this.form.packingTime || this.form.specificationPacking))
    },
    processState() {
      if (this.form.processJson && this.form.processJson.processingProcessInfo) {
        return !!this.form.processJson.processingProcessInfo.some(i => {
          return i.flag
        })
      } else {
        return false
      }
    },
    precent() {
      return 10
    }
  },
  watch: {
    traceCode: {
      async handler(newV) {
        if (newV) {
          await this.getTrace(newV)
        }
      },
      immediate: true
    }
  },
  methods: {
    deepClone,
    img2String,
    showNoBinding(flag) {
      if (!flag) {
        this.popup.iot.show = true
      }
    },
    async getTrace(traceCode) {
      await api.getPackingTraceByTraceCodeJL({ traceCode }).then(res => {
        this.form = { ...res.data }
        this.getIotDeviceNoLogin(this.form.userId)
        this.getCameraListNoLogin(this.form.userId)
      })
    },
    async getIotDeviceNoLogin(userId) {
      await api.getIotDeviceNoLogin({ userId }).then(res => {
        this.deviceState = !!res.data.list
      })
    },
    async getCameraListNoLogin(userId) {
      await api.getCameraListNoLogin({ userId }).then(res => {
        this.cameraState = !!res.data.onlineCameraCount
      })
    },
    // 产品信息
    packingEdit() {
      this.popup.product.visible = true
      this.popup.product.initFormData = {
        productName: this.form.productName,
        productPhoto: this.form.productPhoto,
        specificationPacking: this.form.specificationPacking,
        specificationQuantity: this.form.specificationQuantity,
        specificationUint: this.form.specificationUint,
        packingTime: this.form.packingTime,
        QGPTime: this.form.QGPTime,
        QGPUnit: this.form.QGPUnit
      }
    },
    confirmProductFn(val) {
      this.form = {
        ...this.form,
        ...val
      }
    },
    // 证书
    createReport() {
      this.popup.report.visible = true
      this.popup.report.formType = 'create'
    },
    editReport(i, index) {
      this.popup.report.visible = true
      this.popup.report.formType = 'edit'
      this.popup.report.initFormData = { ...this.deepClone(i), index }
    },
    confirmReportFn(val) {
      if (val.id || val.index >= 0) {
        this.form.reportInfo.splice(val.index, 1, val)
      } else {
        if (!this.form.reportInfo) {
          this.form.reportInfo = []
        }
        this.form.reportInfo.push(val)
      }
    },
    delfirmFn(val) {
      this.form.reportInfo.splice(val, 1)
    },
    // 加工过程
    processEdit() {
      this.popup.process.visible = true
      this.popup.process.initFormData = {
        parPreparedProducts: this.deepClone(this.form.parPreparedProducts)
      }
    },
    confirmProcessFn(val) {
      this.form = {
        ...this.form,
        ...val
      }
    },
    // 原料
    rawEdit() {
      this.popup.raw.visible = true
      this.popup.raw.initFormData = {
        rawMaterialsInfo: this.deepClone(this.form.rawMaterialsInfo)
      }
    },
    confirmRawFn(val) {
      this.form = {
        ...this.form,
        ...val
      }
    },
    // 更新溯源
    submit() {
      const param = {
        ...this.form,
        productPhoto: this.img2String(this.form.productPhoto)
      }
      if (param.reportInfo) {
        param.reportInfo.map(i => {
          i.photo = this.img2String(i.photo)
        })
      }
      api.savePackingTraceJL(param).then(() => {
        this.$toast('更新溯源成功')
        this.$router.push({
          name: 'TracePacking', query: { traceCode: this.traceCode }
        })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.icon {
  width: 20px;
  height: 20px;
}
.improved {
  color: #8ad2ba;
}
.main {
  padding: 10px 16px 50px;
  position: relative;
  .trace-process {
    width: 100%;
    text-align: center;
    background-color: #ffebcb;
    line-height: 36px;
    color: #e85d11;
    font-size: 14px;
    border-radius: 12px;
  }
  .list {
    margin-top: 10px;
  }
  .packing-info {
    color: #3c4048;
  }
  .report-info {
    /deep/ .van-cell__title, .van-cell__value:first-child {
      flex: 2;
    }
  }
  .submit-box {
    display: block;
    width: 100%;
    .submit {
      height: 20px;
      width: 200px;
      position: fixed;
      letter-spacing: 0.2em;
      bottom: 10px;
      left: 0;
      right: 0;
      margin: 10px auto;
      padding: 20px 0 20px 0;
    }
  }
}
</style>
